import { useTranslations } from 'next-intl';
import { type FC } from 'react';

import clsx from 'clsx';

import { Legend } from '@/components/common/charts/Legend';
import { Flex } from '@/components/common/Flex';
import { useDeviceProperties } from '@/hooks/use-device-properties';
import { type WithClassName } from '@/types/react';

import styles from './EmptyPieComparisonPlaceholder.module.scss';

const GATE_BORDER_COLOR = 'dark-green2-13p' as const;

type EmptyPieComparisonPlaceholderProps = WithClassName & {
  gateNames?: readonly [string | undefined, string | undefined];
};

export const EmptyPieComparisonPlaceholder: FC<EmptyPieComparisonPlaceholderProps> = (props) => {
  const t = useTranslations('pages.dashboard.widgets.comparisonPlaceholder');
  const { className, gateNames } = props;
  const { isMobile } = useDeviceProperties();

  return (
    <Flex className={clsx(styles.root, className)}>
      <div className={styles.pie}>
        <div className={styles.inner} />
      </div>

      <Legend
        className={styles.legend}
        direction="column"
        alignItems={isMobile ? 'center' : 'flexEnd'}
        datasets={[
          {
            id: 'gate-1',
            name: t('gate1'),
            value: gateNames?.at(0),
            color: GATE_BORDER_COLOR,
          },
          {
            id: 'gate-2',
            name: t('gate2'),
            value: gateNames?.at(1),
            color: GATE_BORDER_COLOR,
          },
        ]}
        variant="borderOnly"
      />
    </Flex>
  );
};
